const SCHEMA_CONTEXT = 'https://schema.org';

export function buildOrganizationJsonLd({ siteUrl, logoUrl }) {
  if (!siteUrl) return null;
  return {
    '@context': SCHEMA_CONTEXT,
    '@type': 'Organization',
    name: 'Charlee.ai',
    url: siteUrl,
    ...(logoUrl ? { logo: logoUrl } : {}),
  };
}

export function buildWebSiteJsonLd({ siteUrl }) {
  if (!siteUrl) return null;
  return {
    '@context': SCHEMA_CONTEXT,
    '@type': 'WebSite',
    name: 'Charlee.ai',
    url: siteUrl,
  };
}

export function buildArticleJsonLd({
  headline,
  description,
  url,
  image,
  datePublished,
  author,
}) {
  if (!headline || !url) return null;
  const article = {
    '@context': SCHEMA_CONTEXT,
    '@type': 'Article',
    headline,
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    url,
  };
  if (description) article.description = description;
  if (image) article.image = [image];
  if (datePublished) article.datePublished = datePublished;
  if (author) article.author = { '@type': 'Person', name: author };
  return article;
}

export function buildBreadcrumbJsonLd(items) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const withUrls = items.filter((item) => item?.name && item?.url);
  if (withUrls.length === 0) return null;
  return {
    '@context': SCHEMA_CONTEXT,
    '@type': 'BreadcrumbList',
    itemListElement: withUrls.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function compactJsonLd(graph) {
  return graph.filter(Boolean);
}
